import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Ratio from 'react-bootstrap/Ratio'; // Import Ratio for responsive video
import "./Knowledge.css";

function Knowledge() {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <section className="knowledge_section">
        {/* Optional: Add a subtle background overlay */}
        <div className="knowledge_overlay"></div>
        
        <div className="container position-relative">
          <div className="row align-items-center min-vh-50">
            
            {/* Left Side: Content */}
            <div className="col-lg-7 col-md-12">
              <div className="knowledge_content">
                <span className="sub-title">Expert Insights</span>
                <h2 className="knowledge_taital">
                  Meet Dr. Sunil Apsingi
                </h2>
                <p className="knowledge_text">
                  With over two decades of experience in complex orthopedic surgeries, 
                  Dr. Sunil Apsingi shares his philosophy on patient care, 
                  advanced joint replacement techniques, and the future of orthopedics.
                </p>
                <button 
                  className="btn btn-outline-light mt-4 d-lg-none" 
                  onClick={() => setModalShow(true)}
                >
                  Watch Interview
                </button>
              </div>
            </div>

            {/* Right Side: Play Trigger */}
            <div className="col-lg-5 col-md-12 text-center mt-4 mt-lg-0">
              <div className="video_trigger">
                <div 
                  className="play_btn_container" 
                  onClick={() => setModalShow(true)}
                  title="Watch Full Interview"
                >
                  {/* CSS-only Play Triangle */}
                  <div className="play_triangle"></div>
                </div>
                <p className="watch_label mt-3">Watch Full Interview</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="video-modal-content" // Custom class for dark mode modal
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter" className="w-100 text-center">
          Exclusive Interview
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="p-0 bg-black">
        {/* Bootstrap Ratio ensures 16:9 aspect ratio on all devices */}
        <Ratio aspectRatio="16x9">
          <iframe
            src="https://www.youtube.com/embed/lxIaBW3YKpo?autoplay=1&rel=0"
            title="Dr Sunil Apsingi Interview"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Ratio>
      </Modal.Body>
      
      <Modal.Footer className="justify-content-center border-0">
        <Button 
          variant="primary" 
          className="btn-primary-custom"
          onClick={() => window.open('https://www.youtube.com/channel/UCipAoi1WhtRmHFOk7Fk8PgQ', '_blank')}
        >
          View More Videos on YouTube
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Knowledge;